/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgPlay = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={16}
    viewBox='0 0 14 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.90884 0.144515C1.28829 -0.0626461 1.75057 -0.0460874 2.11423 0.187692L12.7203 7.00587C13.0586 7.22333 13.263 7.59786 13.263 7.99999C13.263 8.40212 13.0586 8.77666 12.7203 8.99411L2.11423 15.8123C1.75057 16.0461 1.28829 16.0626 0.90884 15.8555C0.52939 15.6483 0.293335 15.2505 0.293335 14.8182V1.18181C0.293335 0.749494 0.52939 0.351677 0.90884 0.144515ZM2.65697 3.34651V12.6535L9.89573 7.99999L2.65697 3.34651Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgPlay
